import { ResolveErrorComponent } from './resolve-error.component';
export var resolveErrorRoutes = [
    {
        path: 'resolve-error',
        component: ResolveErrorComponent
    }
];
var ResolveErrorRoutingModule = (function () {
    function ResolveErrorRoutingModule() {
    }
    return ResolveErrorRoutingModule;
}());
export { ResolveErrorRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/resolve-error/resolve-error-routing.module.ts.pre-build-optimizer.js